<template>
    <div class="container_box">
         <nav-box @userInfo='getUserInfo'></nav-box>
         <h1 class="announceTitle" >{{announceTitle}}</h1>
         <p class="create_time">{{createTime}}</p>
         <div class="announceContent">{{announceContent}}</div>
    </div>
</template>
<script>
import { mapMutations } from "vuex";
import { request } from "../../network/request";
import NavBox from '../../components/NavBox.vue'

export default ({
    name:'NoticeInfo',
    data(){
        return{
            userInfo:{},
            announceTitle:'',
            createTime:'',
            announceContent:''
        }
    },
    created(){
        request({
            method:'get',
            url:'/api/Announce/Detail',
            params:{
                announceNo:this.taskNo
            }
        }).then(res =>{
            if(res.data.code === 21002){
                this.changeLogin({ userToken: "" });
                this.$router.push('/login')
            }else if(res.data.code === 0){
                this.announceTitle = res.data.content.announceTitle;
                this.createTime = res.data.content.createTime.slice(0,10) +'\xa0\xa0\xa0' + res.data.content.createTime.slice(11,19)
                this.announceContent = res.data.content.announceContent;
                
            }else{
                this.$message({type:'error',message:res.data.msg})
            }
            
        })
    },
    methods: {
        ...mapMutations(["changeLogin"]),
          getUserInfo(val){
            this.userInfo = val;
        },
    },
    computed: {
        taskNo(){
            return this.$route.params.noticeId
        }
    },
    components: {
         NavBox
    }
})
</script>
<style scoped>
    .announceTitle{
        width:800px;
        word-break: break-all;
        margin:0 auto;
        font-size:25px;
        padding-top:150px;
        text-align: center;
        margin-bottom:20px;
    }
    .create_time{
        text-align: center;
        font-size:14px;
        color:#a0a0a0;
    }
    .announceContent{
        width:800px;
        word-break: break-all;
        margin:0 auto;
        margin-top:20px;
        font-size:16px;
        line-height: 35px;
    }
    @media screen and (max-width: 480px){
        .announceTitle{
            width:100%;
            padding:0px 20px;
            padding-top:100px;
        }
        .announceContent{
            width:100%;
            padding:0px 20px;
        }
    }
</style>
